import LinkButton from "components/LinkButton";
import styled from "styled-components";

export const MoreInfoButton = styled(LinkButton)`
  display: block;
  margin-top: 8px;
`;

export const ImageSection = styled.div`
  width: 100%;
  margin: 20px 0;
`;
